import script from "./ChipAppuntamento.vue?vue&type=script&setup=true&lang=js"
export * from "./ChipAppuntamento.vue?vue&type=script&setup=true&lang=js"

import "./ChipAppuntamento.vue?vue&type=style&index=0&id=714f5ab7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alexg\\Desktop\\martech\\whappy-app-front-vue-v2\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-714f5ab7"]])

export default __exports__